import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { GoogleMaps } from './google-maps.namespace';

export function provideDfModuleGoogleMaps(config?: DeepPartial<GoogleMaps.IAppConfig>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: GoogleMaps.OPTIONS,
            useFactory: () => defaultsDeep(config, GoogleMaps.DEFAULT_OPTIONS)
        }
    ]);
}
